import React, { useState } from 'react';
import PropTypes from 'prop-types';
import BasicCheckbox from 'components/BasicCheckbox';

import '../styles.css';

const FiltersAccordionGroupBasic = ({
  title,
  visible = true,
  elements,
  group,
  disabled,
  onChange,
  onSelectAll,
  onClearAll,
}) => {
  const [query, setQuery] = useState('');

  const handleChange = value => {
    onChange(group, value);
  };

  const handleSelectAll = () => {
    onSelectAll(group);
  };

  const handleClearAll = () => {
    onClearAll(group);
  };

  const handleQueryChange = e => {
    setQuery(e.target.value);
  };

  const checkboxes = elements.map(({ value, text, selected }, index) => {
    return !query ||
      (query && text.toLowerCase().includes(query.toLowerCase())) ? (
      <BasicCheckbox
        key={index}
        value={value}
        singleRow
        checked={selected || false}
        title={text.toString()}
        name={value}
        controlFunc={() => handleChange(value)}
        labelStyles={{
          fontFamily: 'Noto Sans, sans-serif',
        }}
      />
    ) : null;
  });

  return visible ? (
    <>
      {elements.length > 10 && !disabled && (
        <div className="filter-group__form">
          <div className="filter-group__input">
            <input
              className="filter-group__query"
              placeholder="Search"
              onChange={handleQueryChange}
              value={query}
            />
          </div>
          <button
            type="button"
            className="filter-group__reset-btn"
            onClick={() => setQuery('')}
          />
        </div>
      )}
      <div className="filter-group__checkbox-list">
        {title && <span className="filter-group__title">{title}</span>}

        {checkboxes}
      </div>
      {!disabled && (
        <div className="filter-group__controls">
          <button
            className="filter-group__control"
            type="button"
            onClick={handleSelectAll}
          >
            Select All
          </button>
          <button
            className="filter-group__control"
            type="button"
            onClick={handleClearAll}
          >
            Clear All
          </button>
        </div>
      )}
    </>
  ) : null;
};

FiltersAccordionGroupBasic.defaultProps = {
  onSelectAllFunc: () => {},
  onClearAllFunc: () => {},
  onChangeFunc: () => {},
  elements: [],
};

FiltersAccordionGroupBasic.propTypes = {
  onSelectAllFunc: PropTypes.func,
  onClearAllFunc: PropTypes.func,
  onChangeFunc: PropTypes.func,
  elements: PropTypes.array,
};

export default FiltersAccordionGroupBasic;
